import React, { FC, ReactNode } from 'react'
import { CardInner } from './index'
import text from 'styles/utility/text.module.scss'

type Props = {
  children: ReactNode
}

const CardOutlinedInner: FC<Props> = (props) => {
  const { children } = props

  return (
    <CardInner>
      <p className={`${text.font_small}`}>{children}</p>
    </CardInner>
  )
}

export default CardOutlinedInner
